<template>
    <div class="card modern-page-card">
        <div class="card-header border-bottom">
            <div class="d-flex flex-wrap align-items-center justify-content-between gap-3">
                <div>
                    <h5 class="mb-1">المخزون</h5>
                    <p class="text-muted small mb-0">عرض فقط لكل دفعات المنتج في جميع المخازن.</p>
                </div>
                <button type="button" class="btn btn-label-primary" disabled>
                    <i class="ti ti-building-warehouse me-1"></i> انتقال إلى إدارة المخزون
                </button>
            </div>
        </div>

        <div class="card-body border-bottom">
            <div class="row g-3">
                <div class="col-md-6">
                    <label class="form-label">فلتر المخزن</label>
                    <select class="form-select" v-model="stockingFilter">
                        <option value="">كل المخازن</option>
                        <option v-for="name in stockingNames" :key="name" :value="name">{{ name }}</option>
                    </select>
                </div>
                <div class="col-md-6">
                    <label class="form-label">فلتر تاريخ الصلاحية</label>
                    <select class="form-select" v-model="expiryFilter">
                        <option value="">كل الدفعات</option>
                        <option value="valid">سليمة</option>
                        <option value="expired">منتهية</option>
                    </select>
                </div>
            </div>
        </div>

        <div class="table-responsive">
            <table class="table modern-grid-table mb-0">
                <thead>
                    <tr>
                        <th>المخزن</th>
                        <th>التشغيلة</th>
                        <th>تاريخ الصلاحية</th>
                        <th>الكمية</th>
                        <th>السعر</th>
                        <th>الحالة</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="!filteredItems.length">
                        <td colspan="6" class="modern-grid-table__empty text-center">لا توجد دفعات مطابقة</td>
                    </tr>
                    <tr v-for="item in filteredItems" :key="item.id">
                        <td>{{ item.stockingName || '---' }}</td>
                        <td>{{ item.batchNumber || item.serialNumber || '---' }}</td>
                        <td>{{ formatDate(item.expiryDate) }}</td>
                        <td>{{ item.quantity || 0 }}</td>
                        <td>{{ formatCurrency(item.price) }}</td>
                        <td>
                            <span class="badge" :class="isExpired(item) ? 'bg-label-danger' : 'bg-label-success'">
                                {{ isExpired(item) ? 'منتهية' : 'سليمة' }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WarehouseStockTab',
    props: {
        stockItems: { type: Array, default: () => [] }
    },
    data() {
        return {
            stockingFilter: '',
            expiryFilter: ''
        };
    },
    computed: {
        stockingNames() {
            return [...new Set((this.stockItems || []).map(x => x.stockingName).filter(Boolean))];
        },
        filteredItems() {
            return (this.stockItems || []).filter(item => {
                if (this.stockingFilter && item.stockingName !== this.stockingFilter) return false;
                if (this.expiryFilter === 'valid' && this.isExpired(item)) return false;
                if (this.expiryFilter === 'expired' && !this.isExpired(item)) return false;
                return true;
            });
        }
    },
    methods: {
        isExpired(item) {
            if (item.isExpired === true || item.IsExpired === true) return true;
            if (!item.expiryDate) return false;
            const expiry = new Date(item.expiryDate);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return expiry < today;
        },
        formatDate(value) {
            if (!value) return '---';
            return new Date(value).toLocaleDateString('ar-LY');
        },
        formatCurrency(value) {
            return Number(value || 0).toLocaleString('ar', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
    }
};
</script>
